import { render, staticRenderFns } from "./RegistroCompradorView.vue?vue&type=template&id=2664326c&scoped=true"
import script from "./RegistroCompradorView.vue?vue&type=script&lang=js"
export * from "./RegistroCompradorView.vue?vue&type=script&lang=js"
import style0 from "./RegistroCompradorView.vue?vue&type=style&index=0&id=2664326c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2664326c",
  null
  
)

export default component.exports